import { render, staticRenderFns } from "./CardDetailInfo.vue?vue&type=template&id=aede6676&scoped=true&"
import script from "./CardDetailInfo.vue?vue&type=script&lang=js&"
export * from "./CardDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailInfo.vue?vue&type=style&index=0&id=aede6676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aede6676",
  null
  
)

export default component.exports